const MAX_NESTING_DEPTH = 5;
const MAX_ANSWER_LENGTH = 20_000;

export const extractPropertyFaqAnswer = (payload: unknown, depth = 0): string | null => {
    if (typeof payload === "string") {
        if (depth < MAX_NESTING_DEPTH) {
            try {
                return extractPropertyFaqAnswer(JSON.parse(payload), depth + 1);
            } catch {
                // A plain string can itself be the answer.
            }
        }

        const answer = payload.trim();
        return answer.length > 0 && answer.length <= MAX_ANSWER_LENGTH ? answer : null;
    }

    if (!payload || typeof payload !== "object" || depth >= MAX_NESTING_DEPTH) {
        return null;
    }

    const response = payload as Record<string, unknown>;
    const candidates = [response.answer, response.response, response.result, response.data, response.body];

    for (const candidate of candidates) {
        const answer = extractPropertyFaqAnswer(candidate, depth + 1);
        if (answer) {
            return answer;
        }
    }

    return null;
};
const MAX_NESTING_DEPTH = 5;
const MAX_ANSWER_LENGTH = 20_000;

export const extractPropertyFaqAnswer = (payload: unknown, depth = 0): string | null => {
    if (typeof payload === "string") {
        if (depth < MAX_NESTING_DEPTH) {
            try {
                return extractPropertyFaqAnswer(JSON.parse(payload), depth + 1);
            } catch {
                // A plain string can itself be the answer.
            }
        }

        const answer = payload.trim();
        return answer.length > 0 && answer.length <= MAX_ANSWER_LENGTH ? answer : null;
    }

    if (!payload || typeof payload !== "object" || depth >= MAX_NESTING_DEPTH) {
        return null;
    }

    const response = payload as Record<string, unknown>;
    const candidates = [response.answer, response.response, response.result, response.data, response.body];

    for (const candidate of candidates) {
        const answer = extractPropertyFaqAnswer(candidate, depth + 1);
        if (answer) {
            return answer;
        }
    }

    return null;
};
